<!-- 进度条 -->
<template>
  <div class="progressbar">
    <div class="progress">
      <div
        class="greenblock"
        :style="{ background: getTransitionColor(color1, color2, i/success) }"
        v-for="(index, i) in success"
        :key="i"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  data() {
    return {
      // success: 23,
      color1: "#2D9E61",
      color2: "#2A6ABA",
    };
  },
  props: {
    success: {
      type: Number,
      default: 0,
    }
  },
  mounted() {
    // console.log(this.getTransitionColor(color1, color2, 0.5));
  },
  methods: {
    // 将十六进制颜色转换为RGB数组
    hexToRgb(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
      ];
    },

    // 获取两种颜色之间的过渡色
    getTransitionColor(color1, color2, ratio) {
      var rgb1 = this.hexToRgb(color1);
      var rgb2 = this.hexToRgb(color2);
      var r = Math.round((rgb2[0] - rgb1[0]) * ratio + rgb1[0]);
      var g = Math.round((rgb2[1] - rgb1[1]) * ratio + rgb1[1]);
      var b = Math.round((rgb2[2] - rgb1[2]) * ratio + rgb1[2]);
      return "rgb(" + r + ", " + g + ", " + b + ")";
    },
    // 调用函数并输出结果
  },
};
</script>

<style scoped lang="less">
.progressbar {
  content: "";
  display: table;
  clear: both;
}
.progress {
  width: 100%;
  height: 100%;
  // margin-top: 4px;
  float: left;
}
.greenblock {
  width: 8px;
  height: 16px;
  margin-left: 4px;
  float: left;
  background: linear-gradient(to right, #0b51c1, #1a89e2);
}
</style>
